import { Typography } from '@/ux-common/components/typography/typography';

interface EmptyStatePlaceholderProps {
  message?: string;
}

export const EmptyStatePlaceholder = ({
  message = 'Nothing to display',
}: EmptyStatePlaceholderProps): React.ReactNode => {
  return (
    <div className="flex items-center justify-center rounded-md bg-muted/50 p-8">
      <Typography as="p" className="text-body-base text-ckds-text-fg-tier3">
        {message}
      </Typography>
    </div>
  );
};
